import { usePage } from "@inertiajs/react";

function Footer() {
  const { name } = usePage().props.wp;

  return (
    <footer className="w-full card-16-equal md:card-40">
      <div className="">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-0">
          <div className="mb-4 md:mb-0 text-sm md:text-base">
            &copy; {new Date().getFullYear()} {name}
          </div>
          <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4">
            <a
              href="#"
              className="text-gray-600 hover:text-primary transition-colors text-sm md:text-base"
            >
              Polityka prywatności
            </a>
            <a
              href="#"
              className="text-gray-600 hover:text-primary transition-colors text-sm md:text-base"
            >
              Regulamin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
